import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '@/components/ui/card'
import { AlertTriangle, Wrench } from 'lucide-react'
import React from 'react'

interface MaintenancePageProps {
    title?: string
    description?: string
    estimatedTime?: string
}

export const MaintenancePage: React.FC<MaintenancePageProps> = ({
    title = "We're performing maintenance",
    description = "We're currently updating our system to bring you a better experience. Please check back soon.",
    estimatedTime = 'We expect to be back online shortly.',
}) => {
    return (
        <div className="flex min-h-screen items-center justify-center p-4 bg-background">
            <Card className="w-full max-w-md text-center">
                <CardHeader className="space-y-4">
                    <div className="bg-warning/10 mx-auto flex size-16 items-center justify-center rounded-full">
                        <Wrench className="size-8 text-warning" />
                    </div>
                    <CardTitle className="text-2xl font-semibold text-foreground">
                        {title}
                    </CardTitle>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground">
                        {description}
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <div className="bg-muted/50 rounded-lg p-4">
                        <div className="flex items-center gap-2 text-sm text-muted-foreground">
                            <AlertTriangle className="size-4" />
                            <span>{estimatedTime}</span>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}
